import { Link } from "react-router-dom";
import { site } from "@/config/site";
import { categories } from "@/mocks/categories";
import NewsletterForm from "@/components/feature/NewsletterForm";

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-100">
      <div className="px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-accent-500 text-foreground-950">
                <i className="ri-fire-line text-xl" aria-hidden="true" />
              </span>
              <span className="font-heading text-lg font-black tracking-wide text-background-50">
                {site.name}
              </span>
            </Link>
            <p className="mt-4 text-sm leading-relaxed text-background-200/80">
              {site.description}
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold tracking-wide text-accent-300">栏目导航</h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/news?cat=${cat.slug}`}
                    className="whitespace-nowrap text-background-200/80 transition-colors hover:text-accent-300"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold tracking-wide text-accent-300">快速入口</h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li>
                <Link to="/" className="text-background-200/80 transition-colors hover:text-accent-300">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/news" className="text-background-200/80 transition-colors hover:text-accent-300">
                  全部瓜料
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-background-200/80 transition-colors hover:text-accent-300">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-background-200/80 transition-colors hover:text-accent-300">
                  投稿与合作
                </Link>
              </li>
            </ul>
          </div>

          <div className="lg:col-span-1">
            <h4 className="font-heading text-sm font-bold tracking-wide text-accent-300">订阅每日瓜报</h4>
            <p className="mt-4 text-sm leading-relaxed text-background-200/80">
              留下邮箱，我们会把当天最值得看的几条瓜料整理好发给你。
            </p>
            <div className="mt-4">
              <NewsletterForm />
            </div>
            <p className="mt-4 flex items-center gap-2 text-sm text-background-200/80">
              <i className="ri-mail-line" aria-hidden="true" />
              <a href={`mailto:${site.email}`} className="transition-colors hover:text-accent-300">
                {site.email}
              </a>
            </p>
          </div>
        </div>
      </div>

      <div className="border-t border-background-100/15 px-4 py-5 md:px-6">
        <div className="flex flex-col items-center justify-between gap-2 text-xs text-background-200/70 sm:flex-row">
          <p>
            © {site.year} {site.name}. 保留所有权利。
          </p>
          <p>本站内容仅供娱乐参考，不构成任何事实认定，请理性吃瓜。</p>
        </div>
      </div>
    </footer>
  );
}